export default {
      id: "ic_facebook-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_facebook-usage",
      toString: function () {
        return this.url;
      }
    }